import { openAlertModal } from '@inflearn/ds-react-next';

export function openMockInterviewStartErrorAlert() {
  openAlertModal({
    title: '면접을 시작하지 못했어요',
    children: '잠시 후 다시 시도해주세요.',
    labels: { confirm: '확인' },
    footerType: 'right',
    confirmProps: { color: 'infgreen', size: 'md' },
  });
}
